module.exports = __webpack_public_path__ + "static/1-811c8c69967f8c4f5f8ad454a0dd865e.jpg";